<div
  class="drawer-container"
  [class.drawer-open]="desktopDrawerActive"
  [class.bottomsheet-open]="mobilePanelRendered()"
  [class.sidenav-open]="nav.sideNavSignal()"
  [class.spartan-ui-shell]="true"
  [class.header-suppressed]="!headerVisible"
>
  <div class="drawer-content">
    @if (headerVisible) {
      <app-header id="app-header" role="banner" />
    }
    <main id="app-body" [attr.inert]="mobilePanelRendered() ? '' : null">
      <div class="sidenav-container">
        @if (nav.sideNavSignal()) {
          <button
            type="button"
            class="shell-backdrop shell-backdrop--sidenav"
            aria-label="Close navigation"
            (click)="closeSidenav()"
          ></button>
        }
        <aside class="sidenav-panel" [class.sidenav-panel-open]="nav.sideNavSignal()"></aside>
        <div class="page-container">
          <ng-content />
        </div>
      </div>
    </main>
  </div>

  <app-drawer class="drawer-route-controller" />

  <app-ui-sheet-shell
    [open]="drawerOpen"
    side="right"
    [ariaLabelledBy]="drawerTitleId"
    [showCloseButton]="false"
    [closeOnBackdropClick]="!dialog.modalOpen()"
    [closeOnOutsidePointerEvents]="false"
    [overlayClass]="rightDrawerOverlayClass"
    [contentClass]="rightDrawerContentClass"
    (closed)="onDrawerSheetClosed()"
  >
    <drawer-content />
  </app-ui-sheet-shell>

  <!-- Browsing details shares navigation with the header; a modal dialog would hide it from assistive technology. -->
  @if (mobilePanelRendered()) {
    <section
      animate.enter="animate-in slide-in-from-bottom duration-detail-enter ease-in-out motion-reduce:animate-none"
      [class]="drawer.bottomSheetOpen() ? '' : 'animate-out slide-out-to-bottom duration-detail-leave ease-in-out motion-reduce:animate-none pointer-events-none'"
      [attr.inert]="drawer.bottomSheetOpen() ? null : ''"
      #mobilePanel
      tabindex="-1"
      role="region"
      [attr.aria-labelledby]="drawerTitleId"
      class="mobile-detail-panel fixed inset-x-0 bottom-0 z-detail-panel flex min-h-0 flex-col overflow-hidden bg-surface-elevated shadow-overlay outline-none"
      [style.top]="headerVisible ? 'var(--app-nav-height)' : '0'"
    >
      <drawer-content />
    </section>
  }
</div>
